module.exports = __webpack_public_path__ + "static/media/share.04cb40c1.svg";